import React, { Component } from 'react';
import { Element } from 'react-scroll';

class Servizi extends Component {
  render() {
    return (
      <Element name="servizi-section">
        <div className="row grey-background">
          <div className="col-lg-7 col-md-9 col-12 mx-auto py-4">
            <h1 className="text-uppercase">Servizi</h1>
            <div className="separator mx-auto mb-3"></div>

            <div className="space"></div>
            <div className="row pt-3 my-4">
              <div className="col-lg-4 col-md-8 col-10">
                <img src="/img/readingLight.jpg" className="img-fluid" />
              </div>
              <div className="col pt-4 pt-md-0">
                <h5 className="text-left text-uppercase"><u>Editing light</u></h5>
                <p className="text-justify">Questo tipo di editing è adatto per testi che non necessitano di grandi sconvolgimenti strutturali e che abbiano già un’impostazione della trama ben definita. In questo caso lavoreremo sulla forma, la sintassi, la scorrevolezza in modo da dare alla storia un ritmo più fluido. È compresa la correzione bozze.
                <br/>
                <br/>
                <b>€ 2 a cartella</b> (1800 caratteri spazi inclusi)</p>
              </div>
            </div>

            <div className="row pt-3 my-4">
              <div className="col-lg-4 col-md-8 col-10">
                <img src="/img/readingIntense.jpg" className="img-fluid" />
              </div>
              <div className="col pt-4 pt-md-0">
                <h5 className="text-left text-uppercase"><u>Editing intenso</u></h5>
                <p className="text-justify">Ideato per chi ha problemi nella trama e nella sua struttura. Lavoreremo sul testo sezionandolo, scartando il superfluo e arricchendolo là dove è necessario, lo ribalteremo come un materasso per dargli la sua forma migliore. È compresa la correzione bozze.
                <br/>
                <br/>
                <b>€ 3 a cartella</b> (1800 caratteri spazi inclusi)</p>
              </div>
            </div>

            <div className="row pt-3 my-4">
              <div className="col-lg-4 col-md-8 col-10">
                <img src="/img/correzioneBozze.jpg" className="img-fluid" />
              </div>
              <div className="col pt-4 pt-md-0">
                <h5 className="text-left text-uppercase"><u>Correzione bozze</u></h5>
                <p className="text-justify">Caccia al refuso! Pulirò il testo da ogni imperfezione grammaticale, ortografica e da ogni tipo di problema sulla punteggiatura. Lo scandaglierò fino in fondo per una pulizia completa.
                <br/>
                <br/>
                <b>€ 1 a cartella</b> (1800 caratteri spazi inclusi)</p>
              </div>
            </div>

            <div className="row pt-3 my-4">
              <div className="col-lg-4 col-md-8 col-10">
                <img src="/img/stop.jpg" className="img-fluid" />
              </div>
              <div className="col pt-4 pt-md-0">
                <h5 className="text-left text-uppercase"><u>Cosa non faccio</u></h5>
                <ul className="text-justify">
                  <li>non faccio lo <b>scrittore</b> ergo non riscrivo paragrafi, pagine o capitoli interi; il ruolo dell’editor non è sostituirsi all’autore</li>
                  <li>non sono un <b>agente</b>: non rappresento gli autori e non dipendo da nessuna agenzia</li>
                  <li>non <b>pubblico</b> libri semplicemente perché non possiedo una casa editrice</li>
                </ul>
                <p className="text-justify">Per lavorare con me mandami una mail spiegandomi qualcosa del tuo libro e del tipo di servizio che ti serve. Allega anche una tua breve nota biografica e la sinossi dettagliata.</p>
              </div>
            </div>


          </div>
        </div>
      </Element>
    );
  }
}

export default Servizi;



// WEBPACK FOOTER //
// ./src/components/Servizi.js